// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'//引入store
import animated from 'animate.css'
import VueWechatTitle from 'vue-wechat-title'
// import 'vueg/css/transition-min.css'
Vue.use(VueWechatTitle)
Vue.use(animated)
Vue.config.productionTip = false

Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'  //关键代码

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.manageLogin)){  // 判断该路由是否需要登录权限
    if (localStorage.getItem('ManageFlag')) {  // 判断当前用户的登录信息loginInfo是否存在
      next();
    } else {
      next({
        path: '/manageLogin'
      })
    }
  }else {
    next();
  }
  if (to.matched.some(m => m.meta.maintainLogin)){  // 判断该路由是否需要登录权限
    if (localStorage.getItem('MaintainFlag')) {  // 判断当前用户的登录信息loginInfo是否存在
      next();
    } else {
      next({
        path: '/maintainLogin'
      })
    }
  }else {
    next();
  }
  // if (to.matched.some(m => m.meta.isLogin)){  // 判断该路由是否需要登录权限
  //   if (localStorage.getItem('Flag')) {  // 判断当前用户的登录信息loginInfo是否存在
  //     next();
  //   } else {
  //     next({
  //       path: '/userLogin'
  //     })
  //   }
  // }else {
  //   next();
  // }
})


// WEBPACK FOOTER //
// ./src/main.js